const defaultOptions = {
  url: '',
  title: '',
  description: '',
  images: {
    general: '/static/app-hotmart-legal/images/share--general.jpg',
    facebook: '/static/app-hotmart-legal/images/share--facebook.jpg',
    twitter: '/static/app-hotmart-legal/images/share--twitter.jpg',
  },
}

export const head = customOptions => {
  const defaultScripts = [
    {
      src: 'https://static.hotmart.com/hot-lgpd/lgdpscript.min.js',
      defer: true,
    },
    {
      type: 'application/ld+json',
      json: customOptions.breadcrumbs,
    },
  ]

  const options = Object.assign({}, defaultOptions, customOptions)
  const title = options.title ? options.title : defaultOptions.title
  const description = options.description ? options.description : defaultOptions.description
  const script = customOptions.script ? [...defaultScripts, ...customOptions.script] : defaultScripts
  const htmlAttrs = customOptions.htmlAttrs
  const link = customOptions.link

  const head = {
    htmlAttrs: { ...htmlAttrs },
    title,
    meta: [
      // Share - General
      { hid: 'url', itemprop: 'url', content: options.url },
      { hid: 'description', name: 'description', content: description },
      { hid: 'image', itemprop: 'image', content: `${process.env.BASE_URL}${options.images.general}` },

      // Share - Facebook
      { hid: 'og:type', property: 'og:type', content: 'website' },
      { hid: 'og:title', property: 'og:title', content: options.title },
      { hid: 'og:description', property: 'og:description', content: description },
      { hid: 'og:image', property: 'og:image', content: `${process.env.BASE_URL}${options.images.facebook}` },
      { hid: 'og:site_name', property: 'og:site_name', content: options.title },
      { hid: 'og:url', property: 'og:url', content: options.url },

      // Share - Twitter
      { hid: 'twitter:card', name: 'twitter:card', content: 'summary' },
      { hid: 'twitter:site', name: 'twitter:site', content: '@hotmart' },
      { hid: 'twitter:creator', name: 'twitter:creator', content: '@hotmart' },
      { hid: 'twitter:url', name: 'twitter:url', content: options.url },
      { hid: 'twitter:title', name: 'twitter:title', content: options.title },
      { hid: 'twitter:description', name: 'twitter:description', content: description },
      { hid: 'twitter:image', name: 'twitter:image', content: `${process.env.BASE_URL}${options.images.twitter}` },
    ],
    script,
    link: [...link, { rel: 'canonical', href: options.canonical }],
  }

  return head
}

export default {
  head,
}
